import { RandomUtils } from '../utils/random-utils';

export enum TicketStatusEnum {
  // Brouillon, the ticket has not been sent by the déclarant
  DRAFT = 'DRAFT',
  // Attente supervision, ticket validated by déclarant, a supervision is required
  WAITING_SUPERVISION = 'WAITING_SUPERVISION',
  // Ajustement, supervisor refused the ticket, déclarant can modify it and re-send
  ADJUSTMENT = 'ADJUSTMENT',
  // Supervisé, validated but at least one API sub basket failed to be sent
  SUPERVISED = 'SUPERVISED',
  // En cours de traitement, ticket was validated by supervision
  IN_PROGRESS = 'IN_PROGRESS',
  // Commandé, all non final sub baskets are ordered (or waiting backorder)
  ORDERED = 'ORDERED',
  // Clôturé, all sub baskets are in a final status
  CLOSED = 'CLOSED',
  // Abandonné, the déclarant abandoned the ticket
  ABANDONED = 'ABANDONED',
}

export interface TicketEquipmentTranslateModel {
  status: TicketStatusEnum;
  translation: string;
}

export const ticketStatusTranslation = (status: TicketStatusEnum) => {
  // switch sur string : accepte aussi les statuts legacy hors enum (voir cas WAITING/EXPIRED)
  switch (status as string) {
    case TicketStatusEnum.DRAFT.toString():
      return 'Brouillon';
    case TicketStatusEnum.WAITING_SUPERVISION.toString():
      return 'En attente de supervision';
    case TicketStatusEnum.SUPERVISED.toString():
      return 'Supervisé';
    case TicketStatusEnum.IN_PROGRESS.toString():
      return 'En cours de traitement';
    case TicketStatusEnum.ORDERED.toString():
      return 'Commandé';
    case TicketStatusEnum.CLOSED.toString():
      return 'Clôturé';
    case TicketStatusEnum.ABANDONED.toString():
      return 'Abandonné';
    // Statuts legacy supprimés de l'enum (PRED-3095) : plus jamais écrits, mais encore
    // présents dans les statusHistory existants (trace d'audit, non migrée). Conservés
    // ici uniquement pour que la timeline affiche un libellé sur les anciennes entrées.
    case 'COMMANDE_ANNULEE':
      return 'Commande annulée';
    case 'AUTHORIZATION_TRANSFERRED':
      return 'Autorisation transférée';
    case 'AUTHORIZATION_IN_PROGRESS':
      return 'Autorisation en cours';
    case 'WAITING':
      return 'En attente de prise en charge';
    case 'EXPIRED':
      return 'Expiré';
    case 'CANCEL':
      return 'Abandonné';
    default:
      return null;
  }
};

export const ticketStatusObject = (status: TicketStatusEnum) => {
  return {
    _id: RandomUtils.generateId(),
    value: status,
    label: ticketStatusTranslation(status),
  };
};

/**
 * Statuts strictement antérieurs à l'envoi en autorisation (sendToAuthorization),
 * seul moment où les sous-paniers sont créés : un ticket dans ces statuts n'a
 * jamais de sous-paniers. Liste d'exclusion (et non d'inclusion) pour rester
 * valide si de futurs statuts post-autorisation sont ajoutés.
 * À garder aligné avec le script de backfill PRED-3094 et
 * sendToAuthorizationToValidators (back).
 */
export const TICKET_STATUSES_WITHOUT_SUB_BASKETS = [TicketStatusEnum.DRAFT, TicketStatusEnum.WAITING_SUPERVISION];

export const ticketStatusHasSubBaskets = (status: TicketStatusEnum): boolean =>
  !TICKET_STATUSES_WITHOUT_SUB_BASKETS.includes(status);

export enum OutOfCatalogStatusEnum {
  NEW = 'NEW',
  REJECTED = 'REJECTED',
  IN_PROGRESS = 'IN_PROGRESS',
  WAITING_CREATOR = 'WAITING_CREATOR',
  FINALIZED = 'FINALIZED',
}

export enum ReadAsEnum {
  CREATOR = 'CREATOR',
  CREATOR_REFERENT = 'CREATOR_REFERENT',
  //  REFERENT_METIER = 'REFERENT_METIER',
  APPROVISIONNEUR = 'APPROVISIONNEUR',
  SUPERVISION = 'SUPERVISION',
  CREATOR_APPROVISIONNEUR = 'CREATOR_APPROVISIONNEUR',
  FORBIDDEN = 'FORBIDDEN',
  VALIDATOR_QUOTE = 'VALIDATOR_QUOTE',
  CREATOR_VALIDATOR_QUOTE = 'CREATOR_VALIDATOR_QUOTE',
  TICKET_VALIDATOR = 'TICKET_VALIDATOR',
  CREATOR_TICKET_VALIDATOR = 'CREATOR_TICKET_VALIDATOR',
  REFERENT_ENGAGEMENT = 'REFERENT_ENGAGEMENT',
}
